<dx-popup
    #boardApprovalEditor
    width="60%"
    height="75%"
    title="Board Approval"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box *ngIf="processEditorResult" width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form
                        #boardApprovalForm
                        *ngIf="selectedRequest"
                        width="100%"
                        height="100%"
                        [colCount]="1"
                        labelLocation="left"
                    >
                        <dxi-item itemType="group" [colCount]="3">
                            <dxi-item>
                                <dxo-label text="Process"></dxo-label>
                                <div *dxTemplate>
                                    <span>
                                        {{ processEditorResult?.proccessDisplayText }} -
                                        <span>
                                            <i
                                                class="dx-theme-accent-as-text-color icon-content"
                                                [ngClass]="iconHelp"
                                                (click)="
                                                    showCiraHelp(
                                                        processEditorResult?.proccessHelpKey,
                                                        selectedRequest.communityId
                                                    )
                                                "
                                            ></i>
                                        </span>
                                    </span>
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <div *dxTemplate>
                                    <dx-button
                                        type="default"
                                        [text]="processButtonTitle"
                                        [hint]="processButtonTitle"
                                        (onClick)="onDetailsClick()"
                                    ></dx-button>
                                </div>
                            </dxi-item>
                            <dxi-item
                                itemType="group"
                                [colCount]="1"
                                *ngIf="
                                    !!selectedRequest &&
                                    !!selectedRequest.process &&
                                    selectedRequest.process.toUpperCase() === 'ACC'
                                "
                            >
                                <dxi-item>
                                    <dxo-label text="Date Submitted"></dxo-label>
                                    <div *dxTemplate>{{ processEditorResult?.dateSubmitted | date: dateFormat }}</div>
                                </dxi-item>
                                <dxi-item>
                                    <dxo-label text="Due Date"></dxo-label>
                                    <div *dxTemplate>{{ processEditorResult?.dueDate | date: dateFormat }}</div>
                                </dxi-item>
                                <dxi-item>
                                    <ng-container *ngIf="!!selectedRequest.daysRemaining">
                                        <ng-container *ngIf="selectedRequest.daysRemaining < 0">
                                            <dxo-label text="Days Overdue"></dxo-label>
                                            <div *dxTemplate>
                                                <div class="cc-error-text-color">
                                                    {{ selectedRequest.daysRemaining * -1 }}
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="selectedRequest.daysRemaining >= 0">
                                            <dxo-label text="Days Remaining"></dxo-label>
                                            <div *dxTemplate>
                                                <div class="dx-theme-accent-as-text-color">
                                                    {{ selectedRequest.daysRemaining }}
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </dxi-item>
                            </dxi-item>
                            <dxi-item
                                *ngIf="
                                    !!selectedRequest &&
                                    !!selectedRequest.process &&
                                    selectedRequest.process.toUpperCase() === 'WF'
                                "
                            >
                                <div *dxTemplate>
                                    <img
                                        class="wf-check-image icon-content"
                                        *ngIf="wfCheckImage"
                                        [src]="wfCheckImage"
                                        (click)="downloadWfCheckImage()"
                                    />
                                </div>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item
                            *ngIf="
                                !!selectedRequest &&
                                !!selectedRequest.process &&
                                selectedRequest.process.toUpperCase() !== 'COLLECTIONS'
                            "
                        >
                            <dxo-label text="Discussion Notes"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-area
                                    [height]="100"
                                    [readOnly]="true"
                                    [(value)]="actionParameter.notes"
                                ></dx-text-area>
                            </div>
                        </dxi-item>
                        <dxi-item [isRequired]="true">
                            <dxo-label [text]="processEditorResult.displayTextForUserSelection"></dxo-label>
                            <div *dxTemplate>
                                <ng-container>
                                    <dx-select-box
                                        displayExpr="displayText"
                                        valueExpr="key"
                                        placeholder=""
                                        [readOnly]="!processEditorResult.allowUserSelection"
                                        [dataSource]="processEditorResult.onBehalfOf"
                                        [(value)]="actionParameter.actionOnBehalfOf"
                                    ></dx-select-box>
                                </ng-container>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Process's Current Status"></dxo-label>
                            <div *dxTemplate>
                                <div class="text-bold">{{ processEditorResult?.proccessCurrentStatus }}</div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate>
                                <h4>Approval Action</h4>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate class="action-button-container">
                                <ng-container *ngFor="let action of processEditorResult?.actions">
                                    <dx-button
                                        class="action-button"
                                        [type]="action.type"
                                        [text]="action.displayText"
                                        [hint]="action.displayText"
                                        [icon]="action.icon"
                                        (onClick)="onActionClick(action)"
                                    ></dx-button>
                                </ng-container>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onCancelClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-board-approval-note-editor
    *ngIf="showBoardApprovalNote"
    [visible]="showBoardApprovalNote"
    [actionResult]="appliedAction"
    [actionParameter]="boardApprovalNoteParameter"
    [popupTitle]="boardApprovalNoteTitle"
    (onClose)="closeBoardApprovalNotes($event)"
></app-board-approval-note-editor>

<app-collection-referral-detail
    *ngIf="showCollectionReferral"
    [visible]="showCollectionReferral"
    [processId]="selectedRequest?.processId"
    [processText]="selectedRequest?.processIdDisplayText"
    [communityId]="selectedRequest?.communityId"
    [collectionsDetail]="collectionsDetail"
    [mode]="mode"
    (onClose)="showCollectionReferral = false"
></app-collection-referral-detail>

<app-architectural-application-editor
    *ngIf="showAccEditor"
    [visible]="showAccEditor"
    [popupTitle]="accEditorTitle"
    [communityId]="accEditorParam.communityId"
    [accItemId]="accEditorParam.accItemId"
    [customerId]="accEditorParam.customerId"
    (closeApplicationEditorPopup)="showAccEditor = false"
></app-architectural-application-editor>

<app-architectural-application-viewer
    *ngIf="showAccDetail"
    [visible]="showAccDetail"
    [popupTitle]="accEditorTitle"
    [accDetailParam]="accEditorParam"
    (closeApplicationEditorPopup)="showAccDetail = false"
></app-architectural-application-viewer>

<app-workflow-viewer
    *ngIf="showWorkflowViewer"
    [viewOnly]="true"
    [workflowId]="selectedRequest?.processId"
    [communityId]="selectedRequest?.communityId"
    (onClose)="showWorkflowViewer = false"
></app-workflow-viewer>
